module.exports = __webpack_public_path__ + "img/book-open-icon.6400cb7f.svg";